<template>
  <ItemTopActions
    v-if="tender"
    :options="{
      id: tender.tenderId,
      number: tender.tenderNumber,
      title: tender.title,
      showParticipantsLink: true,
    }">
    <EntitySubscription
      v-if="tender"
      class="my-auto ml-1"
      mode="icon"
      :value="tender"/>
  </ItemTopActions>
</template>
<script>
import EntitySubscription from 'components/common/elements/EntitySubscription.vue'

export default {
  name: 'TenderTopActions',
  components: {
    EntitySubscription,
  },
  props: {
    tender: {
      type: Object
    }
  },
}
</script>
